import { Typography } from 'glints-aries/es/@next';
import { Blue, Neutral } from 'glints-aries/es/@next/utilities/colors';
import styled from 'styled-components';

export const StyledInputNumberStep = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 580px;
  gap: 20px;

  & > img {
    width: 300px;
    margin: auto;
  }

  & > form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .phone-number-input input {
    box-sizing: border-box;
    height: 40px;
    min-height: 40px;
  }

  [data-disabled='true'] svg {
    fill: ${Blue.S99} !important;
    cursor: pointer;
  }
`;

export const PhoneInputRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;

  > div:last-child {
    flex: 1;
  }
`;

export const CallingCodeDropdownContainer = styled.div`
  position: relative;
`;

export const CallingCodeDropdownSearch = styled.div`
  position: relative;
  padding: 16px;
  width: 385px;
  max-width: min(385px, calc(100vw - 48px));
`;

export const CallingCodeDropdownOptions = styled.div`
  max-height: 330px;
  overflow-y: auto;
`;

export const CallingCodeDropdownSectionTitle = styled(Typography).attrs({
  variant: 'subtitle2',
})`
  padding: 0 16px;
  color: ${Neutral.B40};
  text-transform: uppercase;
`;

export const CallingCodeDropdownOption = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 0;
  background-color: ${Neutral.B100};
  color: ${Neutral.B18};
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${Neutral.B95};
  }
`;

export const CallingCodeDropdownOptionCode = styled.span`
  min-width: 38px;
`;

export const CallingCodeDropdownOptionName = styled.span`
  flex: 1;
`;

export const CallingCodeDropdownNoOptions = styled(Typography).attrs({
  variant: 'body1',
})`
  padding: 0 16px 16px 16px;
  color: ${Neutral.B40};
  text-align: left;
`;

export const ExamplePhoneNumber = styled(Typography).attrs({
  variant: 'subtitle2',
})`
  padding-top: 4px;
  color: ${Neutral.B40};
`;
